import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DELPHI_APP_PATH, isPathWithin } from './useSecretAppShortcuts';

type MasterSearchShortcutEvent = Pick<
  KeyboardEvent,
  'key' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey'
>;

export function isDelphiRoute(pathname: string): boolean {
  // Reuse the canonical path-within helper so Delphi's route boundary is
  // defined in exactly one place (hooks/useSecretAppShortcuts.ts).
  return isPathWithin(pathname, DELPHI_APP_PATH);
}

export function resolveGlobalMasterSearchShortcut(
  event: MasterSearchShortcutEvent,
  pathname: string,
): boolean {
  if (isDelphiRoute(pathname)) return false;
  if (!(event.metaKey || event.ctrlKey) || event.shiftKey || event.altKey) return false;
  return event.key.toLowerCase() === 'k';
}

export function useGlobalMasterSearchShortcut(onOpen: () => void): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!resolveGlobalMasterSearchShortcut(event, pathname)) return;
      event.preventDefault();
      onOpen();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onOpen, pathname]);
}
